import { filterCSSProps, StyleProps, toKebabCase } from "shared/utils/styledComponentUtils";
import styled, { css, StyledInterface } from "styled-components";

export const Txt = styled.span<StyleProps>`
  ${(props) =>
    css`
      ${Object.entries(filterCSSProps(props))
        .map(([key, value]) => `${toKebabCase(key)}: ${value};`)
        .join("\n")}
    `}
`;
